export enum DonateToolRelationships {
  ALUMNI = "ALUMNI",
  STUDENT = "STUDENT",
}
